import { ExpenseInvoiceStatus } from '../Types/expenseInvoice.types';

export const EXPENSE_INVOICE_STATUS_LABELS: Record<ExpenseInvoiceStatus, string> = {
  [ExpenseInvoiceStatus.Draft]: 'Szkic',
  [ExpenseInvoiceStatus.Received]: 'Otrzymana',
  [ExpenseInvoiceStatus.Verified]: 'Zweryfikowana',
  [ExpenseInvoiceStatus.Paid]: 'Opłacona',
  [ExpenseInvoiceStatus.Cancelled]: 'Anulowana',
};

export const getExpenseInvoiceStatusLabel = (status: ExpenseInvoiceStatus): string => {
  return EXPENSE_INVOICE_STATUS_LABELS[status] ?? String(status);
};
